<template>
    <div class="loading-indicator" :class="{'overlay': overlay}" v-if="!name || $loading(name)">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>
</template>

<script>
    export default {
        props: {
            overlay: {type: Boolean, default: false},
            name: {type: String, default: null},
        },
    };
</script>